import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import LogoDark from '/zwizle-logo-dark.svg'

export const Header = () => {
  const location = useLocation()
  const isGamePage = location.pathname.includes('/play/')
  const isStatsPage = location.pathname === '/zword/statistics'
  // Which game's mode-select to return to from a game/stats page - derived
  // from the current path's first segment (/zword/... or /anagram/...).
  const activeGameRoute = location.pathname.startsWith('/anagram') ? '/anagram' : '/zword'
  const [isMobile, setIsMobile] = useState(false)

  // Check if viewport is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 480)
    }

    // Initial check
    checkIfMobile()

    // Add event listener for resize
    window.addEventListener('resize', checkIfMobile)

    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  return (
    <header className="app-header">
      <div className="container">
        <Link to="/" className="app-logo">
          <img src={LogoDark} alt="Zwizle logo" className="h-17 w-auto" />
        </Link>

        <div className="flex items-center gap-3">
          {isGamePage && (
            <Link to={activeGameRoute} className="nav-button">
              {isMobile ? 'Change Mode' : 'Choose Different Mode'}
            </Link>
          )}

          {isStatsPage && (
            <Link to={activeGameRoute} className="nav-button">
              {isMobile ? 'Back' : 'Back to Modes'}
            </Link>
          )}

          {!isGamePage && !isStatsPage && activeGameRoute === '/zword' && location.pathname !== '/' && (
            <Link to="/zword/statistics" className="nav-button">
              {isMobile ? 'Stats' : 'Statistics'}
            </Link>
          )}

          {!isGamePage && location.pathname !== '/account' && (
            <Link to="/account" className="nav-button">
              Account
            </Link>
          )}
        </div>
      </div>
    </header>
  )
}
